export default "__VITE_ASSET__d6feb0a3__"